// extracted by mini-css-extract-plugin
export default {"hidden":"Xrv0pT","container":"Ep3aE3"};